import {Application} from "../../lib/Application.js";
import {SettingsRepository} from "../SettingsRepository.js";
import {CookieSettingsRepository} from "../cookie/CookieSettingsRepository.js";
import {ClickUpClient} from "../../lib/ClickUp/ClickUpClient.js";

/** @param {Application} app **/
export function initCore(app) {
    app.bind(SettingsRepository, CookieSettingsRepository);
    app.bind(ClickUpClient, function () {

        let settingsRepo = app.resolve(SettingsRepository);
        let settings = settingsRepo.get();

        return new ClickUpClient(settings.apiKey);

    });
}